export default __webpack_public_path__ + "static/media/risk-score.73d0fee7.svg";